var image_loading = require( './image-loading' ),
	fade_in       = require( './fade-in' );

var scroll_load = ( function ( $ ) {

	var PAGES_AHEAD      = 2,                              // Pages to load in advance, before the user scrolls to them
		PAGES_PRE_LOADED = parseInt( ScriptData.page_to ), // Number of pages that have already been loaded by the initial request
		PAGES_CONTAINER  = '.stone-grid';                  // Container of pages

	var pages_loaded     = PAGES_PRE_LOADED,
		pages_loading    = false,
		enabled          = true,
		$pages_container = null,
		$spinner         = null,
		scroll_points    = [];

	var _init = function() {
		$pages_container = $( PAGES_CONTAINER );
		$spinner         = $pages_container.next( '.ajax-spinner' );

		_update_clearfixes();
		_add_to_queue( $pages_container.height() );
		_check_next_page();

		$( document ).scroll( _check_next_page );
	};

	var _add_to_queue = function( value ) {
		scroll_points.push( value );
	};

	var _pop_queue = function() {
		scroll_points.shift();
	};

	var _process_new_page = function( $page ) {
		_insert_page( $page );
		pages_loaded++;
		pages_loading = false;
		_update_state();

		if ( scroll_points.length > PAGES_AHEAD ) {
			_pop_queue();
		}

		_add_to_queue( $pages_container.height() );
	};

	var _get_next_page = function() {
		var data = {
			action: 'get_posts',
			scroll_load_nonce: ScriptData.scroll_load_nonce,
			query_vars: ScriptData.query_vars,
			page: pages_loaded + 1
		};

		loading();
		$.post( ScriptData.ajaxurl, data, _received_page ).fail( _handle_post_error );
		pages_loading = true;
	};

	var _handle_post_error = function( response ) {

		console.log( response );
		_enable_paging();
	};

	var _enable_paging = function() {
		$( '.crate-pagination' ).show();

		enabled = false;

		$( document ).off( 'scroll', _check_next_page );

		loaded();
	};

	var _received_page = function( response ) {
		if ( response.html || response.more ) {
			var $page = $( $.parseHTML( response.html ) );

			_process_new_page( $page );

			$( document ).trigger( 'pageloaded', [$page] );

			_check_next_page();
		} else if ( response.success ) {
			enabled = false;
			loaded();
		} else {
			// Treat as an error
			_handle_post_error( response )
		}
	};

	var _insert_page = function( $html ) {
		$html.hide();

		$pages_container.append( $html );
		_update_clearfixes();
		image_loading.init();
		fade_in.add_handlers( $html.find( '.fade-in' ) );

		$html.fadeIn( 600 );

		loaded();
	};

	var _update_clearfixes = function() {
		// Insert clearfix every 2 and 4 items
		$( $pages_container ).find( '.stone-col' ).each( function( index ) {

			if ( ( index + 1 ) % 4 === 0 ) {
				if ( $( this ).next().hasClass( 'stone-col' ) ) {
					$( this ).after( '<div class="clearfix visible-xl visible-lg"></div>' );
				}
			}

			if ( ( index + 1 ) % 3 === 0 ) {
				if ( $( this ).next().hasClass( 'stone-col' ) ) {
					$( this ).after( '<div class="clearfix visible-md"></div>' );
				}
			}

			if ( ( index + 1 ) % 2 === 0 ) {
				if ( $( this ).next().hasClass( 'stone-col' ) ) {
					$( this ).after( '<div class="clearfix visible-xs visible-sm"></div>' );
				}
			}
		});
	};

	var _check_next_page = function() {

		if ( enabled && ! pages_loading ) {

			var get_next_page = false,
				distance_from_bottom = scroll_points[0] - window.scrollY + $pages_container.offset().top - $( window ).height();

			if ( distance_from_bottom < 0 ) {
				get_next_page = true;
			}

			if ( scroll_points.length <= PAGES_AHEAD ) {
				get_next_page = true;
			}

			if ( get_next_page ) {
				_get_next_page();
			}
		}
	};

	var loading = function() {
		$spinner.addClass( 'active' );
	};

	var loaded = function() {
		$spinner.removeClass( 'active' );
	};

	var _update_state = function() {
		if ( ! window.history || ! history.replaceState ) {
			return false;
		}

		var uri = URI( window.location.search );

		if ( ! uri.hasQuery( 'page_from' ) ) {
			uri.addQuery( 'page_from', 1 );
		}

		if ( uri.hasQuery( 'page_to' ) ) {
			uri.removeQuery( 'page_to' );
		}

		uri.addQuery( 'page_to', pages_loaded );

		var new_state = window.location.href.replace( window.location.search, '' );
		new_state += uri.toString();

		window.history.replaceState( null, '', new_state );

		_update_pagination_links();

		return true;
	};

	var _update_pagination_links = function() {
		var data = {
			action: 'get_product_pagination_links',
			pagination_nonce: ScriptData.pagination_nonce,
			current_page: pages_loaded,
			query_vars: ScriptData.query_vars,
			base_url: window.location.origin + window.location.pathname
		};

		$.post( ScriptData.ajaxurl, data, _received_pagination_links );
	};

	var _received_pagination_links = function( response ) {
		if ( response.html ) {
			$( '.crate-pagination' ).replaceWith( response.html );
		}
	};

	if ( $( '.stone-grid' ).length > 0 ) {
		$( document ).on( 'ready', _init );
	}

} ) ( jQuery );

module.exports = scroll_load;